// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"sidebar_sidebar__oJFV6","profilePic":"sidebar_profilePic__R798P","img":"sidebar_img__28HrP"};